import {init} from 'hiya-common/src/entry/index'

import getRoutes from '~/routes'
import {createStore} from '~/stores'

import projectConfig from '../../config'

console.log(1111)
init({
  getRoutes,
  createStore,
  projectConfig,
})
